module.exports = __webpack_public_path__ + "static/img/map.ccd730fc.jpg";